var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHumiditySymbol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#455063;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    className: "cls-1",
    d: "M439.6,309.46l-.19-.38L308.31,63.67a9.45,9.45,0,0,0-16.66,0L226.86,185a9.43,9.43,0,0,0,3.88,12.76h0a9.42,9.42,0,0,0,12.76-3.86L300,88.13,422.55,317.61l.19.37a139.1,139.1,0,1,1-245.54,0l.2-.39L208,260.38a9.43,9.43,0,0,0-3.88-12.76h0a9.42,9.42,0,0,0-12.76,3.87L160.6,309.08c0,.13-.13.27-.2.4a157.93,157.93,0,1,0,279.21,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    className: "cls-1",
    d: "M343.2,306.53A9.43,9.43,0,0,0,330.32,310l-77,133.28a9.43,9.43,0,0,0,16.11,9.81l.22-.38,77-133.28A9.43,9.43,0,0,0,343.2,306.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    className: "cls-1",
    d: "M249.65,294.57a38.49,38.49,0,1,0,38.49,38.48h0A38.52,38.52,0,0,0,249.65,294.57Zm0,58.11a19.63,19.63,0,1,1,19.63-19.63h0A19.64,19.64,0,0,1,249.65,352.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    className: "cls-1",
    d: "M311.88,429.67a38.49,38.49,0,1,0,38.48-38.49h0A38.54,38.54,0,0,0,311.88,429.67ZM350.36,410a19.63,19.63,0,1,1-19.62,19.63A19.63,19.63,0,0,1,350.36,410Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    className: "cls-1",
    d: "M217.45,232.09a9.43,9.43,0,1,0-9.43-9.43h0A9.44,9.44,0,0,0,217.45,232.09Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumiditySymbol);
export default __webpack_public_path__ + "static/media/humidity-symbol.3436937aab0b1ad0b9ce2771adc261f2.svg";
export { ForwardRef as ReactComponent };